import { initializeApp } from "firebase/app";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";

const appConfig = {
  //apiPrefix: "http://3.110.223.199/api",
  // apiPrefix: "http://localhost:3001/api",
  REACT_APP_googleMapsApiKey: "AIzaSyAvSjnWQUePxdqFM1vF5bpR6ERYN1Fy8m4",
  apiPrefix: "https://api.bf-junction.in/api",
  // apiPrefix: " https://testapi.bf-junction.in/api",
  //  apiPrefix:"http://192.168.1.12:3001/api",
  authenticatedEntryPath: "/home",
  unAuthenticatedEntryPath: "/sign-in",
  awsS3Path: "https://bfjnonprod.s3.ap-south-1.amazonaws.com/",
  tourPath: "",
  enableMock: false,
  firebaseConfig: {
    apiKey: "AIzaSyAdXI3bG3SDeU7Au5qKC3bxEKOOul7tvs4",
    authDomain: "biofuel-be8c6.firebaseapp.com",
    projectId: "biofuel-be8c6",

    storageBucket: "biofuel-be8c6.appspot.com",
    messagingSenderId: "618046823971",
    appId: "1:618046823971:web:c4187f7177cc4851555b96",
    measurementId: "G-VJG19YC2MM",
  },
  fcmKey:
    "BDLUviM-rSHvSqT0SaS1rofi9m1hzRADfgA7qrz5UWmMcm9_i_v1fa94md5Vn5lqSo2zqh72uPqWDGjsTlr5SuQ",
  Whatsapp: {
    Api: "https://waba.smsmenow.in/restapi/requestjson.php",
    source: "917021014197",
    apiKey: "dd88cea8b3ff50fa",
    VERIFY_OTP_TEMPLATE_ID: "5567",
  },
};

export default appConfig;
